import { CharacterEntity, db } from '@/shared/lib/db'
import { BaseLocalRepository } from '@/shared/services/repository/BaseRepository'
import { Character } from '@storyverse/shared'

class CharacterRepository extends BaseLocalRepository<CharacterEntity> {
    constructor() {
        super(db.characters, 'characters')
    }

    async getByProjectId(projectId: string): Promise<CharacterEntity[]> {
        return this.table.where('projectId').equals(projectId).toArray()
    }

    async saveCharacter(character: Character) {
        const entity: CharacterEntity = {
            ...character,
            id: character.id || crypto.randomUUID(),
            created_at: character.created_at || new Date(),
            updated_at: new Date()
        }

        await this.save(entity)
        return entity
    }

    async deleteCharacter(id: string) {
        await this.delete(id)
    }
}

export const characterRepository = new CharacterRepository()
